module.exports = __webpack_public_path__ + "static/Kenya-logo-33d07a0e6d8add2fb7f41a5eafe6e847.png";